<app-features-container
  [header]="'+INSTALLATIONS.INSTALLATION.PANEL.BOILER' | translate"
  [overlayType]="availableOverlays.System"
>
  <ng-container feature *ngIf="devicesOfV2Cascade$ | async as devices">
    <app-feature-tile
      *ngFor="let device of devices; trackBy: trackBy"
      feature
      isFullWidth="true"
      [isDynamicHeight]="true"
      label="{{
        device.shortDeviceName ||
          ('+INSTALLATIONS.INSTALLATION.CASCADES.MULTIVALENT.DEVICE.' +
            device.deviceType.toUpperCase() | translate) +
            ' ' +
            (getCascadeMemberId(device.id) | async | value2: featurePropertyKey.value:'')
      }}"
      [value]="device.boilerSerial | dash"
    >
    </app-feature-tile>
  </ng-container>
</app-features-container>
